import { ChildItemInfo } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject } from 'aurelia-dependency-injection';

@autoinject()
export class ChildItemInfoService {
	async list(parameters) {
		return await this.repository.findPath(this.repository.getResource() + '/list', parameters);
    }

	getNew(): any {
		return this.repository.getNewEntity();
	}

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(ChildItemInfo);
	}

	async save(updated: ChildItemInfo) {
		return await this.repository.transport.post(this.repository.getResource() + "/updateChildItemInfo", updated);
	}
  

	async getChildren(parameters) {
		return await this.repository.findPath(this.repository.getResource() + '/children', parameters);
	}

}
